<template>
  <div class="row content-box full-height page_container">
    <woot-wizard class="small-12 medium-3 columns" :items="items" />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    items() {
      const data = this.$t('TEAMS_SETTINGS.EDIT_FLOW.WIZARD');
      return data;
    },
  },
};
</script>
